/* eslint-disable no-empty */
import env from '@/utils/env';
import tools from '@/utils/tools';

const addUrlParams = (url, params) => {
  let newUrl = url;
  Object.keys(params).forEach((key) => {
    if (params[key] === undefined || params[key] === null) {
      return;
    }
    if (newUrl.indexOf('?') > newUrl.indexOf('#')) {
      // 已经有query并且属于hash中的, 或者仅有query
      newUrl = `${newUrl}&${key}=${encodeURIComponent(params[key])}`;
    } else {
      newUrl = `${newUrl}?${key}=${encodeURIComponent(params[key])}`;
    }
  });
  return newUrl;
};

/**
 * 获取跳转到新认证的url
 *   name： 路由名字
 *   query：url参数
 */
const getNewUrl = async (name, query) => {
  let configModule = {};
  let nativeModule = {};
  let config = configModule.default || {};
  let Native = nativeModule.default || {};
  let newUrl = 'https://m.hellobike.com/AppHitchDriverApplyH5/latest/index.html';
  try {
    configModule = (await import('@/const/app.const.js')) || {};
    nativeModule = (await import('@/utils/nativeProxy/index')) || {};
    config = configModule.default || {};
    Native = nativeModule.default || {};
    newUrl = config.HITCH_API;
  } catch (error) {}

  if (
    name === 'audit'
    || name === 'driv-apply-simplified/add-driv-info'
    || name === 'driv-apply-simplified/add-driv-info-real'
  ) {
    newUrl = `${newUrl}#/audit`;
  } else if (name === 'driver-register') {
    newUrl = `${newUrl}#/driver-register`;
  } else if (name === 'edit-car-info/edit') {
    // 编辑车辆
  }

  let token = '';
  let ticket = '';
  try {
    // eslint-disable-next-line no-shadow
    const res = await Native.getTokenAndKey();

    token = res.token;
    ticket = res.ticket;
    // eslint-disable-next-line no-empty
  } catch (error) {}

  newUrl = addUrlParams(newUrl, {
    ...query,
    token,
    ticket,
    bizScene:
      {
        HITCH_NORMAL: 201,
        HITCH_ECONOMIC: 202,
      }[query.bizScene]
      || query.bizScene
      || 201,
    applyMethod:
      {
        // 前置认证
        FRONT: '0',
        // 后置认证
        POST: '1',
        // 精简版
        SIMPLE: '2',
        // 完整版
        OVERALL: '3',
        // 极速版
        FAST: '4',
        // 极速有图版
        FAST_ALL: '5',
        // 车辆修改
        VEHICLE_UPDATE: '6',
        // 车辆申诉
        VEHICLE_COMPLAIN: '7',
      }[query.applyMethod] || query.applyMethod,
  });

  return newUrl;
};

export default async function (name, query, next) {
  try {
    const version = env.appVersion;
    if (env.isEasyBikeApp || env.isHitchIndepApp) {
      const drivApplyApiModule = (await import('@/api/drivApply.js')) || {};
      const drivApplyApi = drivApplyApiModule.default || {};
      const drivApplyRes = await drivApplyApi.registerConfigVersion({
        version,
      });

      if (drivApplyRes.needUpdate) {
        next({ name: 'update-app-version', query: {} });
        return true;
      }
    }

    // 兜底逻辑
    if (name === 'edit-car-info/edit') {
      // 哈啰出行app内 只要版本低于 5.72.1 全部跳转到下载页面
      // if (env.isEasyBikeApp && tools.versionCompare(version, '5.71.1') === -1) {
      //   const recruitApiModule = (await import('@/api/recruit.js')) || {};
      //   const recruitApi = recruitApiModule.default || {};
      //   const res = await recruitApi.getTwoCarsGrey();
      //   const grey = res[0].greyResult;
      //   if (grey) {
      //     next({
      //       name: 'update-app-version',
      //       query: { errorType: 'editError' },
      //     });
      //     return true;
      //   }
      // }

      /**
       * 编辑车辆废弃，全部跳转至提示页面
       */
      next({
        name: 'update-app-version',
        query: { errorType: env.isEasyBikeApp || env.isHitchIndepApp ? 'editError' : '' },
      });
      return true;
      // 编辑车辆 全部跳转到新的
      // return false;
    }

    // 车主认证灰度逻辑
    if (env.isEasyBikeApp && tools.versionCompare(version, '5.71.0') === -1) {
      return false;
    }

    // 灰度逻辑
    // let recruitApiModule = {};
    // try {
    //   recruitApiModule = (await import('@/api/recruit.js')) || {};
    // } catch (error) {}

    // const recruitApi = recruitApiModule.default || {};
    // let res = [];
    // let grey = false;
    // try {
    //   res = await recruitApi.getTwoCarsGrey();
    //   grey = res[0].greyResult;
    // } catch (error) {}
    // if (!grey) {
    //   return false;
    // }

    const newUrl = await getNewUrl(name, query);

    window.location.replace(newUrl);
    return true;
  } catch (error) {
    return false;
  }
}
